<template>
  <div class="page flex-col">
    <div class="header">
      <div class="headerBox">
        <p class="logo"></p>
        <div class="nav" ref="bookmark">
          <a href="#page1"><div class="menu-li nav1 active">トップ</div></a>
          <a href="#page2">
            <div class="menu-li nav2">黄金城争覇戦</div>
          </a>
          <a href="#page3">
            <div class="menu-li nav3">公式Twitter</div>
          </a>
          <a href="#page4">
            <div class="menu-li nav5">ゲーム紹介</div>
          </a>
        </div>
        <div class="navButtons">
          <a
              href="javascript:;"
              @click="
              statistics('go_twitter', 'twitter', 'https://twitter.com/saikyousangoku')
              ">
            <div class="navBtnTw">&nbsp;</div>
          </a>
          <a
              href="javascript:;"
              @click="
              statistics('go_yt', 'yt', 'https://www.youtube.com/channel/UCXQITKnHu0Pdvp8SnQUuCAg')
              ">
            <div class="navBtnUt">&nbsp;</div>
          </a>
          <a href="https://gamewith.jp/saikyou-sangoku/" target="_blank">
            <div class="navBtn">&nbsp;</div>
          </a>
        </div>
      </div>
    </div>
    <div class="image-wrapper_5 flex-col">
        <div class="rightBtns">
          <a
      href="javascript:;"
      @click="statistics('go_apple', 'apple', 'https://apps.apple.com/jp/app/id6445888623')"
      >
            <img
              class="image_8"
              referrerpolicy="no-referrer"
              src="./assets/img/app_store2.png"
            />
          </a>
          <a
          href="javascript:;"
          @click="statistics('go_gp', 'gp', 'https://play.google.com/store/apps/details?id=com.guru.byfzjp.an')"
          >
            <img
              class="image_9"
              referrerpolicy="no-referrer"
              src="./assets/img/google_play2.png"
            />
          </a>
          <a
          href="javascript:;"
          @click="statistics('go_twitter', 'twitter', 'https://twitter.com/saikyousangoku/')"
          >
            <img
              class="image_9"
              referrerpolicy="no-referrer"
              src="./assets/img/right_twitter.png"
            />
          </a>
          <a href="https://gamewith.jp/saikyou-sangoku/" target="_blank">
            <img
              class="image_9"
              referrerpolicy="no-referrer"
              src="./assets/img/right_gamewith.png"
            />
          </a>
          <img
            @click="backToTop"
            class="image_10"
            referrerpolicy="no-referrer"
            src="./assets/img/to_top.png"
          />
        </div>
      </div>
    <div class="box_1 flex-col">
      <div class="page page1">
        <a name="page1"></a>
        <div class="inner">
          <div class="image-wrapper_2 flex-row" @click="playVideo()">
            <img
              class="image_3"
              referrerpolicy="no-referrer"
              src="./assets/img/btn_play.png"
            />
          </div>
          <div class="image-wrapper_3 flex-row justify-between">
            
          <a
              href="javascript:;"
              @click="
              statistics('go_apple', 'apple', 'https://apps.apple.com/jp/app/id6445888623')
              ">
              <img
                class="image_4"
                referrerpolicy="no-referrer"
                src="./assets/img/app_store.png"
              />
          </a>
            <a
              href="javascript:;"
              @click="
              statistics('go_gp', 'gp', 'https://play.google.com/store/apps/details?id=com.guru.byfzjp.an')
              ">
              <img
                class="image_5"
                referrerpolicy="no-referrer"
                src="./assets/img/google_play.png"
              />
            </a>
          </div>
          <div class="image-wrapper_4 flex-row">
            <a href="#page1">
              <img
                class="image_6"
                referrerpolicy="no-referrer"
                src="./assets/img/down.png"
              />
            </a>
          </div>
        </div>
      </div>
      
      <div class="page page4">
        <a name="page2"></a>
        <div class="inner">
          <div class="box_7 flex-row">
            <div class="text-group_2 flex-col">
              <span class="paragraph_1"
                >1.「黄金城争覇戦」は、本ゲームが正式サービス開始後に行われるイベントです。<br />
                2.正式サービス開始後、ゲーム内2年目(約5-8日目)の終了時点で戦績順位1位のプレヤ
                ーに、ゲーム内専用称号「戦場殺神」と現物の金インゴット、限定印鑑をプレゼント
                します。<br />
                3.「黄金城争覇戦」イベントは、正式サービス開始後のサーバー「1ー23」（合計23組）
                のみの参加となります。<br />
                <span class="focus">4. 詳細情報とイベント規約は<router-link to='/gold/' target="_blank">こちら</router-link>をご覧ください。</span><br/>
                ※画像はイメージです。実際の賞品とはデザイン・仕様が一部異なる場合がございます。
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="page page5">
        <a name="page3"></a>
        <div class="inner">
          <div class="box_8 flex-row justify-between">
            <div class="image_20">
              <div class="inner">
                <!--tw-->
                <a class="twitter-timeline" href="https://twitter.com/saikyousangoku?ref_src=twsrc%5Etfw">Tweets by saikyousangoku</a> 
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page page6">
      <a name="page4"></a>
      <div class="image-wrapper_12 flex-row justify-between">
        <div class="swiper heroesSwiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="outer">
                <img class="image-game" src="./assets/img/desc/1-game.jpg" />
                <img class="image-name name1" src="./assets/img/desc/1-name.png" />
                <img class="image-role" src="./assets/img/desc/1-role.png" />
                <img class="image-text text1" src="./assets/img/desc/1-text.png" />
              </div>
            </div>
            <div class="swiper-slide">
              <div class="outer">
                <img class="image-game" src="./assets/img/desc/2-game.jpg" />
                <img class="image-name name2" src="./assets/img/desc/2-name.png" />
                <img class="image-role" src="./assets/img/desc/2-role.png" />
                <img class="image-text text2" src="./assets/img/desc/2-text.png" />
              </div>
            </div>
            <div class="swiper-slide">
              <div class="outer">
                <img class="image-game" src="./assets/img/desc/3-game.jpg" />
                <img class="image-name name3" src="./assets/img/desc/3-name.png" />
                <img class="image-role" src="./assets/img/desc/3-role.png" />
                <img class="image-text text3" src="./assets/img/desc/3-text.png" />
              </div>
            </div>
            <div class="swiper-slide">
              <div class="outer">
                <img class="image-game" src="./assets/img/desc/4-game.jpg" />
                <img class="image-name name4" src="./assets/img/desc/4-name.png" />
                <img class="image-role" src="./assets/img/desc/4-role.png" />
                <img class="image-text text4" src="./assets/img/desc/4-text.png" />
              </div>
            </div>
            <div class="swiper-slide">
              <div class="outer">
                <img class="image-game" src="./assets/img/desc/5-game.jpg" />
                <img class="image-name name5" src="./assets/img/desc/5-name.png" />
                <img class="image-role" src="./assets/img/desc/5-role.png" />
                <img class="image-text text5" src="./assets/img/desc/5-text.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <img
        class="image_29"
        referrerpolicy="no-referrer"
        src="./assets/img/i_right.png"
      />
      <img
        class="image_30"
        referrerpolicy="no-referrer"
        src="./assets/img/i_left.png"
      />
    </div>
    <div class="page page7">
      <a name="page5"></a>
      <div class="inner">
        <div class="box_10 flex-col">
          <div class="image-wrapper_13 flex-row">
            <img
              id="fbShare"
              class="image_31"
              referrerpolicy="no-referrer"
              src="./assets/img/fb2.png"
            />
            <img
              id="twShare"
              class="image_32"
              referrerpolicy="no-referrer"
              src="./assets/img/twitter2.png"
            />
            <img
              id="lineShare"
              class="image_33"
              referrerpolicy="no-referrer"
              src="./assets/img/line2.png"
            />
          </div>
          <div class="privacy-txt">
            <a href="https://www.guru-game.com/terms/20009/jp/" target="_blank">利用規約<i class="i-separate"></i></a>
            <a href="https://www.guru-game.com/policy/20009/jp/" target="_blank">個人情報政策<i class="i-separate"></i></a>
            <a href="https://www.guru-game.com/specific-business/20009/jp/" target="_blank">特定商取引法<i class="i-separate"></i></a>
            <a href="https://www.guru-game.com/shikin/20009/jp/" target="_blank">資金決済法</a>
          </div>
        </div>
      </div>
    </div>

    <van-popup v-model="showDialog" class="dialog">
      <div class="group_3 flex-col">
        <div class="box_3 flex-col" @click="showDialog = false"></div>
      </div>
    </van-popup>
    <van-popup v-model="showErr" class="dialog">
      <div>
        <div class="text-wrapper_2">
          <div class="box_3 flex-col" @click="showErr = false"></div>
          <div class="flex paragraph_5">
            {{ errMsg }}
          </div>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="showAVideo" class="dialog">
      <div>
        <div class="box_20 flex-row">
          <div class="box_3 flex-col" @click="closeVideo()"></div>
          <iframe
            width="100%"
            height="100%"
            :src="url"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          ></iframe>
        </div>
      </div>
    </van-popup>
    <!--      </van-overlay>-->
  </div>
</template>

<script src="../../../public/swiper-bundle.min.js"></script>

<script>
  import ImageNumbers from "./ImageNumbers";
  import { gameBook, showGameBookCount } from "@/api/api";

  export default {
    components: { ImageNumbers },
    name: "PC",
    data() {
      return {
        constants: {},
        showDialog: false,
        showMenu: false,
        showTop: true,
        radio: "",
        heroesSwiper: null,
        showErr: false,
        errMsg: "",
        showAVideo: false,
        menuIndex: 0,
        headerHeight: 0,
        videoUrl: "https://www.youtube.com/embed/upVmyaHo31I",
        url: '',
      };
    },
    created() {
      
      // 统计代码
      fbq('init', '891618478609129');
      fbq('track', 'PageView');

      ttq.load('CGHA3G3C77UAPU79KULG');
      ttq.page();

      gtag('js', new Date()); 
      gtag('config', 'G-4G7Q8PPE9W'); 
    },
    mounted() {
      this.showMenu = false;
      this.handleScroll()
      window.addEventListener("scroll", this.handleScroll, true);

      // TODO set demo, must call when total changes
      this.heroesSwiper = new Swiper(".heroesSwiper", {
        loop: true,
        allowTouchMove: true,
        navigation: {
          nextEl: ".image_30",
          prevEl: ".image_29",
        },
      });

      this.shareFunc();
    },
    //methods中定义事件
    methods: {
      // 打点统计
      statistics(name, label, url) {
        window.gtag('event', name, {'event_label': label});
        // 新开链接跳转
        if (url) {
          window.open(url);
        }
      },
      shareFunc() {
        var sharePic = "https://www.guru-game.com/saikyousangoku/share.jpg"; //  分享图片地址
        var shareTxt =
          "アジアの「三国志」ファンを魅了した新世代本格SLGにご注意を! "; // 分享内容
        var shareTitle =
          "【最強三国~黄金城の決戦】好評配信中!"; // 分享标题
        var shareUrl = "https://www.guru-game.com/saikyousangoku"; // 分享地址

        document.getElementById("fbShare").onclick = function () {
          fbShare(shareUrl, shareTitle, sharePic);
          window.gtag("event", "go_facebook", { event_label: "facebook" });
        };
        function fbShare(link, caption, picture) {
          FB.ui(
            {
              method: "feed",
              link: link,
              caption: caption,
              picture: picture,
            },
            function (response) {
              if (response && !(response.error_code == 4201)) {
                console.log("quit");
              }
            }
          );
        }

        var twitterShareTxt =
          "アジアの「三国志」ファンを魅了した新世代本格SLGにご注意を! \n【最強三国~黄金城の決戦】好評配信中!\n\n#最強三国~黄金城の決戦\n#最強三国\n#好評配信中\n\n"; // 分享内容
        
        document.getElementById("twShare").onclick = function () {
          window.open(
            "http://twitter.com/share?url=" +
              encodeURIComponent(shareUrl) +
              "&text=" +
              encodeURIComponent(twitterShareTxt),
            "twitter",
            "height=500, width=750, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no"
          );
          window.gtag("event", "go_twitter", { event_label: "twitter" });
        };

        document.getElementById("lineShare").onclick = function () {
          window.open(
            "https://social-plugins.line.me/lineit/share?url=" +
              encodeURIComponent(shareUrl) +
              "&text=" +
              encodeURIComponent(shareTxt + "\n" + shareTitle) +
              "&display=popup&ref=plugin&src=share_button",
            "height=500, width=750, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no"
          );
          window.gtag("event", "go_line", { event_label: "line" });
        };
      },
      top(el) {
        function getElementTop(elem) {
          var elemTop = elem.offsetTop; //获得elem元素距相对定位的父元素的top
          elem = elem.offsetParent; //将elem换成起相对定位的父元素
          while (elem != null) {
            //只要还有相对定位的父元素
            //获得父元素 距他父元素的top值,累加到结果中
            elemTop += elem.offsetTop; //再次将elem换成他相对定位的父元素上;
            elem = elem.offsetParent;
          }
          return elemTop;
        }
        return getElementTop(el);
      },
      handleScroll() {
        var scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        if(!this.headerHeight) {
          this.headerHeight = document.querySelectorAll(".header")[0].offsetHeight;
        }
        let DOM = document.querySelectorAll(".page");
        for (let i = 0; i < DOM.length; i++) {
          let top = this.top(DOM[i]);
          if (scrollTop < top - this.headerHeight) {
            this.menuIndex = i - 1;
            break;
          } else {
            if (i >= DOM.length - 1) {
              this.menuIndex = i;
            }
          }
          let DOM2 = document.querySelectorAll(".menu-li");
          for (let index = 0; index < DOM2.length; index++) {
            if (i - 1 === index) {
              DOM2[index].classList.add("active");
            } else {
              DOM2[index].classList.remove("active");
            }
          }
        }
      },
      playVideo() {
        this.showAVideo = true;
        window.gtag("event", "playvideo", { event_label: "playvideo" });
        this.url = this.videoUrl
      },
      closeVideo() {
        this.showAVideo = false;
        this.url = ''
      },
      handleShowMenu() {
        this.showMenu = true;
      },
      handleCloseMenu() {
        this.showMenu = false;
      },
      backToTop() {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      },
    },
  };
</script>
<style scoped lang="css" src="./assets/index.css"/>
